import $ from "jquery";
import "jquery-textcomplete";

export const initNoteComponentEditor = (editor) => {
  var user_search_url = $(editor).data("userSearchUrl");
  // Check for @mentions
  $(editor).textcomplete(
    [
      {
        match: /(^|\s)@([^@]*)$/i,
        index: 2,
        search: function (term, callback) {
          $.ajax({
            type: "get",
            url: user_search_url + "?search=" + term,
            success: function (userArray) {
              callback(userArray);
            },
            error: function () {
              callback([]);
            },
          });
        },
        template: function (user) {
          var wrapper = $("<div/>");

          var profilePictureEl = $("<div/>", {
            class: "profile-picture round",
          }).css({
            "background-image": "url(" + user.profile_picture_url + ")",
          });

          var detailsEl = $("<div/>", {
            class: "details",
          });
          var nameEl = $("<div/>", {
            class: "name",
          }).html(user.fullname);

          var emailEl = $("<div/>", {
            class: "email",
          }).html(user.email);

          if (user.email) {
            detailsEl.append(nameEl).append(emailEl);
          } else {
            detailsEl.addClass("no-email");
            detailsEl.append(nameEl);
          }

          wrapper.append(profilePictureEl).append(detailsEl);
          return wrapper.html();
        },
        replace: function (user) {
          var tagEl = $("<input/>", {
            class: "tag ping",
            type: "button",
            "data-role": "none",
          });
          tagEl.val("@" + user.fullname);
          tagEl.attr("data-value", user.id);
          tagEl.attr("data-user-id", user.id);
          return " " + tagEl[0].outerHTML + " ";
        },
      },
    ],
    {
      dropdownClassName: "dropdown autocomplete",
      zIndex: 1350,
      maxCount: 5,
      rightEdgeOffset: 0,
      debounce: 250,
    },
  );
};
